import { render, staticRenderFns } from "./DeauthTgHint.vue?vue&type=template&id=0fe14523&scoped=true"
import script from "./DeauthTgHint.vue?vue&type=script&lang=js"
export * from "./DeauthTgHint.vue?vue&type=script&lang=js"
import style0 from "./DeauthTgHint.vue?vue&type=style&index=0&id=0fe14523&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe14523",
  null
  
)

export default component.exports